'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'reflect-vertical';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e665';
var svgPathData = 'M71 41c-6.9-6.9-8.9-17.2-5.2-26.2S78.3 0 88 0L360 0c9.7 0 18.5 5.8 22.2 14.8S383.8 34.1 377 41L241 177c-9.4 9.4-24.6 9.4-33.9 0L71 41zM0 256c0-13.3 10.7-24 24-24l400 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 280c-13.3 0-24-10.7-24-24zM65.8 497.2c-3.7-9-1.7-19.3 5.2-26.2L207 335c9.4-9.4 24.6-9.4 33.9 0L377 471c6.9 6.9 8.9 17.2 5.2 26.2S369.7 512 360 512L88 512c-9.7 0-18.5-5.8-22.2-14.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faReflectVertical = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;